const rankingItems = [
  { rank: 1, title: '流浪地球3', type: '科幻 / 冒险', hot: '本周播放 128.6万', img: 'https://readdy.ai/api/search-image?query=Epic%20space%20adventure%20movie%20poster%20style%2C%20giant%20planet%20engines%2C%20dramatic%20orange%20lighting%2C%20cinematic%20composition%2C%20sci-fi%20aesthetic&width=400&height=240&seq=rank-wandering-97&orientation=landscape' },
  { rank: 2, title: '封神第二部：战火西岐', type: '神话 / 史诗', hot: '本周播放 96.3万', img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20battle%2C%20heroic%20warrior%20silhouette%2C%20golden%20mist%2C%20dramatic%20scale%2C%20cinematic%20lighting&width=400&height=240&seq=rank-fengshen-97&orientation=landscape' },
  { rank: 3, title: '奥本海默', type: '传记 / 剧情', hot: '本周播放 87.5万', img: 'https://readdy.ai/api/search-image?query=Dramatic%20historical%20figure%20portrait%20style%2C%20black%20and%20white%20cinematic%2C%20intense%20expression%2C%20high%20contrast%2C%20moody%20lighting&width=400&height=240&seq=rank-oppenheimer-97&orientation=landscape' },
  { rank: 4, title: '哪吒之魔童闹海', type: '动画 / 奇幻', hot: '本周播放 72.8万', img: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20hero%2C%20vibrant%20red%20and%20gold%2C%20dynamic%20action%20pose%2C%20mythological%20style%2C%20cinematic%20lighting&width=400&height=240&seq=rank-nezha-97&orientation=landscape' },
  { rank: 5, title: '沙丘2', type: '科幻 / 冒险', hot: '本周播放 65.1万', img: 'https://readdy.ai/api/search-image?query=Desert%20planet%20epic%20scene%2C%20sand%20dunes%20at%20sunset%2C%20grand%20scale%2C%20warm%20golden%20lighting%2C%20cinematic%20wide%20shot&width=400&height=240&seq=rank-dune-97&orientation=landscape' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2 text-center">
          热门排行
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          本周播放量TOP5，看看大家都在看什么
        </p>
        <div className="max-w-3xl mx-auto space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-50 border border-background-200/70 rounded-xl p-3 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 group"
            >
              <div className={`w-10 h-10 flex-shrink-0 rounded-lg flex items-center justify-center font-heading text-lg font-bold ${
                item.rank === 1 ? 'bg-accent-500 text-black' :
                item.rank === 2 ? 'bg-secondary-300 text-secondary-800' :
                item.rank === 3 ? 'bg-secondary-200 text-secondary-700' :
                'bg-secondary-100 text-secondary-600'
              }`}>
                {item.rank}
              </div>
              <div className="w-20 h-14 flex-shrink-0 rounded-lg overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-bold text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </p>
                <p className="text-xs text-foreground-500">{item.type}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-xs font-semibold text-accent-600 whitespace-nowrap">{item.hot}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}